<section class="dark:text-white pt-8 md:pt-16" dir="ltr">
  <div class="flex flex-col justify-center items-center">
    <h1 class="text-4xl md:text-6xl tracking-tight font-extrabold text-center lg:ltr:text-left lg:rtl:text-right">
      {{ 'ABOUT.ABOUT-US-TITLE' | translate }}
    </h1>
    <div
      class="gap-16 items-center py-8 px-4 mx-auto lg:grid lg:grid-cols-2 lg:py-16 lg:px-6"
    >
      <div class="font-light">
        <p class="mb-4 text-gray-500 sm:text-lg dark:text-gray-400">
          {{ 'ABOUT.ABOUT-US' | translate }}
        </p>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-8">
        <div class="col-span-2">
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/information_md_philip_strong_a3ed9ea48a.webp"
            priority
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/information_sm_philip_strong_7cf9f7bac2.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/information_md_philip_strong_a3ed9ea48a.webp 1920w
            "
            sizes="(min-width: 1920px) 890px, (min-width: 1540px) 698px, (min-width: 1280px) 570px, (min-width: 1040px) 984px, (min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1280"
            alt="Almanjobs als Wegweiser"
            class="w-full rounded-xl"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class=" pt-8 md:pt-16" dir="ltr">
  <div>
    <h1
      class="text-4xl tracking-tight px-7 font-extrabold text-center lg:ltr:text-left lg:rtl:text-right dark:text-white"
    >
      {{ 'ABOUT.ALMANJOBS-STORY' | translate }}
    </h1>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 py-8 px-4 mx-auto">
    <div class="grid grid-cols-2 p-0 md:grid-rows-1 md:grid-cols-1 md:p-16 lg:grid-cols-2 lg:p-0 gap-4 mt-8 order-2 md:order-1 items-center">
      <img
        src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_chair_md_annie_spratt_52363e1aab.webp"
        srcset="
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_chair_sm_annie_spratt_aba6748a74.webp  640w,
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_chair_md_annie_spratt_52363e1aab.webp 1920w
        "
        sizes="(min-width: 1920px) 455px, (min-width: 1540px) 359px, (min-width: 1280px) 295px, (min-width: 1040px) 322px, (min-width: 780px) 354px, (min-width: 680px) 290px, calc(47.22vw - 22px)"
        width="1920"
        height="2879"
        alt="office content 2"
        loading="lazy"
        class="mt-4 w-full lg:mt-10 rounded-xl"
      />
      <img
        src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_md_annie_spratt_67c41500b8.webp"
        srcset="
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_sm_annie_spratt_071619852c.webp  640w,
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/office_md_annie_spratt_67c41500b8.webp 1920w
        "
        sizes="(min-width: 1920px) 455px, (min-width: 1540px) 359px, (min-width: 1280px) 295px, (min-width: 1040px) 322px, (min-width: 780px) 354px, (min-width: 680px) 290px, calc(47.22vw - 22px)"
        width="1920"
        height="2879"
        alt="office content 1"
        loading="lazy"
        class="w-full rounded-xl"
      />
    </div>
    <div class="sm:py-16 px-4 lg:px-6 order-1 md:order-2">
      <ol class="relative border-s border-gray-200 dark:border-gray-700">
        <li class="mb-10 ms-10">
          <span
            class="absolute flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full -start-5 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="spark-bulb w-8 h-10 mt-2"
            ></div>
          </span>
          <h3
            class="flex items-center mb-1 text-lg font-semibold dark:text-white"
          >
            {{ 'ABOUT.FIRST-STATION.TITLE' | translate }}
          </h3>
          <time
            class="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
            >{{ 'ABOUT.FIRST-STATION.TIME' | translate }}</time
          >
          <p
            class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400"
          >
            {{ 'ABOUT.FIRST-STATION.EXPLANATION' | translate }}
          </p>
        </li>
        <li class="mb-10 ms-10">
          <span
            class="absolute flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full -start-5 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="research w-7 h-9 ml-[2px] mt-[2px]"
            ></div>
          </span>
          <h3 class="mb-1 text-lg font-semibold dark:text-white">
            {{ 'ABOUT.SECOND-STATION.TITLE' | translate }}
          </h3>
          <time
            class="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
            >{{ 'ABOUT.SECOND-STATION.TIME' | translate }}</time
          >
          <p class="text-base font-normal text-gray-500 dark:text-gray-400">
            {{ 'ABOUT.SECOND-STATION.EXPLANATION' | translate }}
          </p>
        </li>
        <li class="ms-10">
          <span
            class="absolute flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full -start-5 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="project-launch w-6 h-8 mt-[7px]"
            ></div>
          </span>
          <h3 class="mb-1 text-lg font-semibold dark:text-white">
            {{ 'ABOUT.THIRD-STATION.TITLE' | translate }}
          </h3>
          <time
            class="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
            >{{ 'ABOUT.THIRD-STATION.TIME' | translate }}</time
          >
          <p class="text-base font-normal text-gray-500 dark:text-gray-400">
            {{ 'ABOUT.THIRD-STATION.EXPLANATION' | translate }}
          </p>
        </li>
      </ol>
    </div>
  </div>
</section>

<section class=" pt-8 md:pt-16" dir="ltr">
  <div class="py-8 px-4 mx-auto sm:py-16 lg:px-6">
    <div class="max-w-screen-md mb-8 lg:mb-16">
      <h1
        class="mb-4 text-4xl tracking-tight font-extrabold text-center lg:ltr:text-left lg:rtl:text-right dark:text-white"
      >
        {{ 'ABOUT.PEOPLE-IN-MIND.TITLE' | translate }}
      </h1>
      <p class="text-gray-500 sm:text-xl dark:text-gray-400">
        {{ 'ABOUT.PEOPLE-IN-MIND.EXPLANATION' | translate }}
      </p>
    </div>
    <div
      class="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-12 md:space-y-0"
    >
      <div>
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="fairness w-9 h-9 mt-2"
            ></div>
          </div>
          <h3
            class="px-2 ltr:ml-2 rtl:mr-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.FAIRNESS' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.FAIRNESS-EXPLANATION' | translate }}
        </p>
      </div>
      <div>
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="responsibility w-8 h-10 mt-2"
            ></div>
          </div>
          <h3
            class="px-2 ltr:ml-2 rtl:mr-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.RESPONSIBILITY' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.RESPONSIBILITY-EXPLANATION' | translate }}
        </p>
      </div>
      <div>
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="trust w-9 h-9 mt-2"
            ></div>
          </div>
          <h3
            class="px-2 ltr:ml-2 rtl:mr-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.TRUST' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.TRUST-EXPLANATION' | translate }}
        </p>
      </div>
      <div>
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="appriciation w-8 h-8 mt-1"
            ></div>
          </div>
          <h3
            class="px-2 ltr:ml-2 rtl:mr-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.APPRICIATION' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.APPRICIATION-EXPLANATION' | translate }}
        </p>
      </div>
      <div>
        <!-- check this on an actual device -->
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center content-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <div
              [class.white-svg]="(activeTheme$ | async) === 'dark'"
              class="comfort w-7 h-8 mt-2"
            ></div>
          </div>
          <h3
            class="px-2 ltr:ml-2 rtl:mr-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.COMFORT' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.COMFORT-EXPLANATION' | translate }}
        </p>
      </div>
      <!-- <div>
        <div class="flex flex-row content-center mb-4">
          <div
            class="flex justify-center items-center w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900"
          >
            <svg
              class="w-5 h-5 text-primary-600 lg:w-6 lg:h-6 dark:text-primary-300 fill-slate-800 dark:fill-white"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <h3
            class="px-2 mt-2 sm:mb-2 text-xl font-bold dark:text-white content-center"
          >
            {{ 'ABOUT.OUR-VALUES.PROACTIVE' | translate }}
          </h3>
        </div>
        <p class="text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-VALUES.PROACTIVE-EXPLANATION' | translate }}
        </p>
      </div> -->
    </div>
  </div>
</section>

<section class=" pt-8 md:pt-16" [dir]="languageDirection">
  <div class="py-8 px-4 mx-auto lg:py-16 lg:px-6">
    <div class="mx-auto mb-8 lg:mb-16">
      <h2
        class="mb-4 text-4xl tracking-tight font-extrabold text-center lg:ltr:text-left lg:rtl:text-right dark:text-white"
      >
        {{ 'ABOUT.OUR-TEAM.TITLE' | translate }}
      </h2>
      <p
        class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400"
      >
        {{ 'ABOUT.OUR-TEAM.EXPLANATION' | translate }}
      </p>
    </div>
    <div class="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
      <div
        class="items-center bg-gray-50 rounded-xl shadow sm:flex dark:bg-gray-800 dark:border-gray-700"
      >
        <a href="#">
          <img
            [dir]="languageDirection"
            class="sm:max-h-[30rem] ltr:md:max-h-[70rem] rtl:md:max-h-[50rem] lg:max-h-[30rem] rounded-t-xl sm:rounded-t-none rtl:sm:rounded-r-lg ltr:sm:rounded-l-lg"
            src="/assets/images/staff/houman.webp"
            alt="Houman"
          />
        </a>
        <div class="p-5">
          <h3
            class="text-xl font-bold tracking-tight dark:text-white"
          >
            <div>{{ 'ABOUT.OUR-TEAM.HOUMAN' | translate }}</div>
          </h3>
          <span class="text-gray-500 dark:text-gray-400">{{
            'ABOUT.OUR-TEAM.CEO' | translate
          }}</span>
          <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">
            {{ 'ABOUT.OUR-TEAM.CEO-RESPONSIBILITY' | translate }}
          </p>
          <!-- <ul class="flex space-x-4 sm:mt-0">
            <li>
              <a
                href="#"
                class="text-gray-500 hover:text-gray-900 dark:hover:text-white"
              >
                <svg
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                    clip-rule="evenodd"
                  />
                </svg>
              </a>
            </li>
          </ul> -->
        </div>
      </div>
      <div
        class="items-center bg-gray-50 rounded-xl shadow sm:flex dark:bg-gray-800 dark:border-gray-700"
      >
        <a href="#">
          <img
          [dir]="languageDirection"
          class="sm:max-h-[37rem] ltr:md:max-h-[76rem] rtl:md:max-h-[65rem] lg:max-h-[37rem] rounded-t-xl sm:rounded-t-none rtl:sm:rounded-r-lg ltr:sm:rounded-l-lg"
          src="/assets/images/staff/shayan.webp"
          alt="Shayan"
        />
        </a>
        <div class="p-5">
          <h3
            class="text-xl font-bold tracking-tight dark:text-white"
          >
            <div>{{ 'ABOUT.OUR-TEAM.SHAYAN' | translate }}</div>
          </h3>
          <span class="text-gray-500 dark:text-gray-400">{{
            'ABOUT.OUR-TEAM.CTO' | translate
          }}</span>
          <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">
            {{ 'ABOUT.OUR-TEAM.CTO-RESPONSIBILITY' | translate }}
          </p>
          <!-- <ul class="flex space-x-4 sm:mt-0">
            <li>
              <a
                href="#"
                class="text-gray-500 hover:text-gray-900 dark:hover:text-white"
              >
                <svg
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                    clip-rule="evenodd"
                  />
                </svg>
              </a>
            </li>
          </ul> -->
        </div>
      </div>
      <div
      class="items-center bg-gray-50 rounded-xl shadow sm:flex dark:bg-gray-800 dark:border-gray-700"
    >
      <a href="#">
        <img
        [dir]="languageDirection"
        class="sm:max-h-[34rem] ltr:md:max-h-[80rem] rtl:md:max-h-[57rem] lg:max-h-[34rem] rounded-t-xl sm:rounded-t-none rtl:sm:rounded-r-lg ltr:sm:rounded-l-lg"
        src="/assets/images/staff/marzieh.webp"
        alt="Marzieh"
      />
      </a>
      <div class="p-5">
        <h3
          class="text-xl font-bold tracking-tight dark:text-white"
        >
          <div>{{ 'ABOUT.OUR-TEAM.MARZIEH' | translate }}</div>
        </h3>
        <span class="text-gray-500 dark:text-gray-400">{{
          'ABOUT.OUR-TEAM.CMO' | translate
        }}</span>
        <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">
          {{ 'ABOUT.OUR-TEAM.CMO-RESPONSIBILITY' | translate }}
        </p>
      </div>
    </div>
    </div>
  </div>
</section>
